import { render, staticRenderFns } from "./leaveDetail.vue?vue&type=template&id=55993e39&"
import script from "./leaveDetail.vue?vue&type=script&lang=js&"
export * from "./leaveDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports